import { render, staticRenderFns } from "./DeleteSupplier.vue?vue&type=template&id=267e7db0&scoped=true"
import script from "./DeleteSupplier.vue?vue&type=script&lang=js"
export * from "./DeleteSupplier.vue?vue&type=script&lang=js"
import style0 from "./DeleteSupplier.vue?vue&type=style&index=0&id=267e7db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e7db0",
  null
  
)

export default component.exports